import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-12 py-4 md:py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 md:gap-3">
              <a href="/" className="text-2xl md:text-3xl font-bold text-[#1a2332] cursor-pointer" style={{ fontFamily: 'Noto Serif KR, serif' }}>
                후니국담
              </a>
              <div className="hidden sm:block text-sm md:text-base text-gray-600">국담 - 국어를 담다</div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-10">
              <button
                onClick={() => scrollToSection('home')}
                className="text-base text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                홈
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-base text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                학원소개
              </button>
              <button
                onClick={() => scrollToSection('courses')}
                className="text-base text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                강좌안내
              </button>
              <button
                onClick={() => scrollToSection('teachers')}
                className="text-base text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                강사진
              </button>
              <button
                onClick={() => scrollToSection('schedule')}
                className="text-base text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                시간표
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-base text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                상담문의
              </button>
            </div>

            {/* Desktop CTA Button */}
            <button
              onClick={() => scrollToSection('contact')}
              className="hidden lg:block px-7 py-3.5 bg-[#1a2332] text-white text-base rounded-full hover:bg-[#ff6b6b] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              수강 상담 신청
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-[#1a2332] cursor-pointer"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* Mobile Menu Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white z-50 transform transition-transform duration-300 lg:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-6 pt-20">
          <div className="flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('home')}
              className="text-left text-lg text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer py-2 border-b border-gray-100"
            >
              홈
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-left text-lg text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer py-2 border-b border-gray-100"
            >
              학원소개
            </button>
            <button
              onClick={() => scrollToSection('courses')}
              className="text-left text-lg text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer py-2 border-b border-gray-100"
            >
              강좌안내
            </button>
            <button
              onClick={() => scrollToSection('teachers')}
              className="text-left text-lg text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer py-2 border-b border-gray-100"
            >
              강사진
            </button>
            <button
              onClick={() => scrollToSection('schedule')}
              className="text-left text-lg text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer py-2 border-b border-gray-100"
            >
              시간표
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-left text-lg text-[#1a2332] hover:text-[#ff6b6b] transition-colors duration-300 cursor-pointer py-2 border-b border-gray-100"
            >
              상담문의
            </button>

            <button
              onClick={() => scrollToSection('contact')}
              className="mt-4 w-full py-3.5 bg-[#1a2332] text-white text-base rounded-full hover:bg-[#ff6b6b] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              수강 상담 신청
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
